import { render, staticRenderFns } from "./PublicHeader.vue?vue&type=template&id=0e1ffb36&scoped=true"
import script from "./PublicHeader.vue?vue&type=script&lang=js"
export * from "./PublicHeader.vue?vue&type=script&lang=js"
import style0 from "./PublicHeader.vue?vue&type=style&index=0&id=0e1ffb36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1ffb36",
  null
  
)

export default component.exports